// THE BACKEND HOST, IN ONE PLACE.
//
// Before this file there were nine. The AWS cutover moved sign-in, the database and
// storage by setting REACT_APP_SUPABASE_URL and REACT_APP_API_URL in Netlify, and the
// deployed bundle still carried twenty-seven references to the old host:
//
//   https://api.survaihealth.com      11
//   https://survai-api.onrender.com   27
//
// Only five of those were `X || "https://survai-api.onrender.com"` fallbacks, dead once
// the variable was set. TWENTY-ONE WERE UNCONDITIONAL — literal
// fetch("https://survai-api.onrender.com/api/...") calls gated by nothing — across user
// administration (create, invite, delete, reset-password, unlock), the dev-password
// gate, security-alert email, and the parse and batch jobs. Five more modules baked the
// host into a constant of their own.
//
// THAT WAS NOT AN AVAILABILITY PROBLEM, IT WAS A DATA ONE. The old API is configured
// against the old database. So after the cutover, signing in read the new database while
// inviting or creating a user wrote to the old one — accounts existing in one and not the
// other, with no error anywhere. Availability would have been the kinder failure.
//
// ── WHY A MODULE AND NOT A CONSTANT PER FILE ──────────────────────────────────
//
// Nine copies is how eight of them get updated. Every one of those constants was
// individually reasonable where it stood; what made them a bug is that no single edit
// could move them all, so the next migration has the same twenty-seven-site problem.
// test/no-backend-host-is-hardcoded.test.js fails if a literal host reappears.
//
// ── ON THE DEFAULT ────────────────────────────────────────────────────────────
//
// It is the CURRENT host, not the retired one. The old constants all defaulted to Render,
// which meant an unset variable pointed a build at a backend that is being switched off —
// silently, and in the direction of the thing that breaks. Defaulting forward means the
// worst case of a missing variable is a build that is already correct.
//
// Create React App inlines process.env.REACT_APP_* at BUILD time, so this is baked into
// the bundle. A site pointed at the wrong backend is fixed by rebuilding, not by a reload.
// public/index.html reads the same variable through %REACT_APP_API_URL% for the two
// globals it has to set before any module loads.

const FALLBACK = "https://api.survaihealth.com";

// Trailing slashes are stripped because every call site appends a rooted path. A value of
// "https://host/" would otherwise produce "https://host//api/auth/login", which some
// proxies normalise and some answer with a redirect that drops the POST body.
export const API_BASE = String(process.env.REACT_APP_API_URL || FALLBACK).replace(/\/+$/, "");

// The PointClickCare proxy, which cmsAdapter derives its own URL from by swapping the
// suffix — so this has to keep ending in exactly /api/pcc.
export const PCC_BASE =
  (typeof window !== "undefined" && window.PCC_PROXY_URL) || `${API_BASE}/api/pcc`;

export default API_BASE;
